// extracted by mini-css-extract-plugin
module.exports = {"header":"_7ccddba","preview":"_b821625","report":"_4d7fa49","itemTitle":"_a7384d7","contentHeadline":"_9bdb9d0","description":"_dc58a36"};